import * as React from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Button } from '@mui/material';
import PoDashboard from 'components/po/PoDashboard';
import { setPoDashboardPoList } from 'store/slice/PharmaSlice';
import PoSelectionMgmt from './components/PoSelectionMgmt';
import PharmaorderEditFormOnly from './PharmaorderEditFormOnly';
import PoEditFormImplFormOnly from 'components/po/PoEditFormImplFormOnly';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={{backgroundColor:'grey'}}
    >
      {value === index && <Box sx={{ p: .5 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function PharmaorderEditFormImpl() {
  const dispatch = useDispatch();
  
  const {poList} = useSelector((state)=>state.pharmaslice)
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(()=>{
    dispatch(setPoDashboardPoList(
      poList.filter((obj=>obj.partyid===parseInt(pharmaorderObj.partyid)))
  ))},[])

  const getTabs = ()=> {
    if (null!==pharmaorderObj.partyid && pharmaorderObj.id!==undefined){
      return <>
              <Tab label="PO Management" {...a11yProps(1)} />
              <Tab label="Select PO" {...a11yProps(2)} />
      </>
    }
    return <></>
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

        {pharmaorderObj && pharmaorderObj.id!=undefined ?
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Order Info" {...a11yProps(0)} />
              <Tab label="PO Management" {...a11yProps(1)} />
              <Tab label="Select PO" {...a11yProps(2)} />
          </Tabs>
        :
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Order Info" {...a11yProps(0)} />
            </Tabs>
        }
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Grid >
          <PharmaorderEditFormOnly/>
        </Grid>
        
      </CustomTabPanel>
      
      <CustomTabPanel value={value} index={1}>
      <Box lg={11} xs={11} sx={{ flexGrow: 1 }}>
        <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight:{lg:window.screen.height-480, xs:window.screen.height-500}, maxWidth:window.screen.width-60 }}>
        <PoDashboard/>
        </Grid>
      </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
      <Grid >
        <PoSelectionMgmt/>
      </Grid>
      </CustomTabPanel>

  
    </Box>
  );
}